import React, { useState } from "react"

import Layout from "./Layout"
import Seo from "./Seo";//TODO - set title below

import 'typeface-roboto'

import Pwa from './Pwa/';
import IDANativeBridge from "./IDANativeBridge";
import { useAllEntities } from "../hooks/all-entities";
import { useAllModules } from "../hooks/all-modules";
import { EntityRepository } from "../repository/EntityRepository";
import { GlobalContext } from "./GlobalContext";
import { ModuleRepository } from "../repository/ModuleRepository";

const Wrapper = ({ children, ...props }) => {
    const { pageContext: { defaultLocale }, entity: { locale, Components } } = props;

    const [player, setPlayer] = useState(null);
    const [fullscreenMode, setFullscreenMode] = useState(Components?.some(component => component.fullscreen === true));
    const entityRepository = new EntityRepository(useAllEntities());
    const moduleRepository = new ModuleRepository(useAllModules());

    return (
        <GlobalContext.Provider value={{ player, setPlayer, fullscreenMode, setFullscreenMode, 
                                         entityRepository, moduleRepository }}>
            <Layout {...props}>
                <IDANativeBridge {...props}>
                    <Pwa {...props} />
                    <Seo title={`${props.entity?.title || props.entity?.identifier || 'Home'}`} lang={locale || defaultLocale} />
                    {children}
                </IDANativeBridge>
            </Layout>
        </GlobalContext.Provider>
    )
}


export default Wrapper;
